export default __webpack_public_path__ + "images/no-car-image.svg";